import { DatePickerInput, DateValue } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';

import { endOfDay, startOfDay } from '@/utils/dates';

type DateRangeProps = {
  label: string;
  placeholder: string;
  value: [DateValue, DateValue];
  onChange: (value: [DateValue, DateValue]) => void;
};

const normalizeDateRange = (dates: [DateValue, DateValue]): [DateValue, DateValue] => {
  const [from, to] = dates;

  if (from && !to) {
    return [startOfDay(from), null];
  }

  if (from && to) {
    return [startOfDay(from), endOfDay(to)];
  }

  return [null, null];
};

export const DateRange = ({ label, placeholder, value, onChange }: DateRangeProps) => {
  return (
    <DatePickerInput
      leftSection={<IconCalendar size={18} stroke={1.5} />}
      type="range"
      label={label}
      placeholder={placeholder}
      value={value}
      valueFormat="DD.MM.YYYY"
      allowSingleDateInRange
      onChange={(dates) => onChange(normalizeDateRange(dates))}
    />
  );
};
